export default {"src":"/_next/static/media/family_40.bae26973.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};